export default "__VITE_ASSET__BmVuYqzZ__"